// Number formatting for the UI. Monospace-friendly, compact.

import { gas, money, unitPrice } from "@degen/shared/money";

/** WUSD amounts (symbol from config/content.ts). */
export const wusd = money;

export function compact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e6) return `${(n / 1e6).toFixed(abs >= 1e7 ? 1 : 2)}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(abs >= 1e4 ? 1 : 2)}k`;
  return String(Math.round(n));
}

/** Tiny token prices: 3 significant digits (W$0.0000046 style). */
export const price = unitPrice;

export function pct(n: number): string {
  const v = n * 100;
  return `${v >= 0 ? "+" : ""}${Math.abs(v) >= 100 ? v.toFixed(0) : v.toFixed(1)}%`;
}

/** In-game minutes ago -> "now", "12m", "3h", "2d". */
export function ago(ticks: number): string {
  if (ticks < 1) return "now";
  if (ticks < 60) return `${ticks}m`;
  if (ticks < 1440) return `${Math.floor(ticks / 60)}h`;
  return `${Math.floor(ticks / 1440)}d`;
}

export function tokens(n: number): string {
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
  return n.toFixed(0);
}

/** wusd() that tolerates NaN from half-typed inputs. */
export const wusdSafe = money;

export { gas as dgn };

/** Up/down colors from the active palette (colorblind-safe mode swaps them to blue/orange). */
export function upDown(): { up: string; down: string } {
  const cs = getComputedStyle(document.documentElement);
  return { up: cs.getPropertyValue("--up").trim() || "#22c55e", down: cs.getPropertyValue("--down").trim() || "#ef4444" };
}
